import { NumberUtils } from '../common/numberUtils';

export enum ConsumptionUnitEnum {
  EURO = 'EURO',
  KWH = 'KWH',
}

export namespace ConsumptionUnitEnum {
  export const formatValue = (unit: ConsumptionUnitEnum, value?: number) =>
    value != null ? `${NumberUtils.parse(value, 2)} ${getSymbol(unit)}` : null;

  export const getSymbol = (value: ConsumptionUnitEnum) => {
    switch (value) {
      case ConsumptionUnitEnum.EURO:
        return '€';
      case ConsumptionUnitEnum.KWH:
        return 'kWh';
      default:
        return '';
    }
  };
}
